import { RootState, TypedDispatch } from "../../../../redux/store";
import { connect } from "react-redux";
import {
  DeleteInboundEmailData,
  EmailConfigDTO,
  EmailConfigData,
  ImapSyncData,
  InboundInitialStateDTO,
} from "../service/types";
import {
  configEmail,
  deleteInboundEmail,
  getMailConfigsList,
  getMailEntriesByInstitute,
  imapSyncEmail,
  saveEmailConfigDetails,
} from "../service/inboundSlice";
import { NurtureLead } from "../../Nurture/service/types";
import { nurtureLead } from "../../Nurture/service/nurtureSlice";
import EmailListing from "../components/EmailListing/EmailListing";

interface StateProps extends InboundInitialStateDTO {}

interface DispatchProps {
  CongigEmail(data: EmailConfigDTO): void;
  CreateEnquiry(data: NurtureLead): void;
  GetMailConfigList(id: string): void;
  GetMailEntriesByInstitute(
    id: string,
    lastEvaluatedKey: string,
    limit: number,
    lastEvaluatedSortKey: string
  ): void;
  SaveEmailConfigurationDetails(data: EmailConfigData): void;
  DeleteEmails(data: DeleteInboundEmailData): void;
  ImapEmailSync(data: ImapSyncData): void;
}

const mapStateToProps = (state: RootState): StateProps => {
  return {
    success: state.inbound.success,
    error: state.inbound.error,
    loading: state.inbound.loading,
    mailList: state.inbound.mailList,
    mailById: state.inbound.mailById,
    mailConfigsList: state.inbound.mailConfigsList,
    importCsvData: state.inbound.importCsvData,
    templateData: state.inbound.templateData,
    importHistoryData: state.inbound.importHistoryData,
    contactList: state.inbound.contactList,
    downloadHistoryData: state.inbound.downloadHistoryData,

    emailConfigSuccess: state.inbound.emailConfigSuccess,
    emailConfigError: state.inbound.emailConfigError,
    emailConfigLoading: state.inbound.emailConfigLoading,
    deleteEmailSuccess: state.inbound.deleteEmailSuccess,
    deleteEmailError: state.inbound.deleteEmailError,
    deleteEmailLoading: state.inbound.deleteEmailLoading,
    imapSyncLoading: state.inbound.imapSyncLoading,
    imapSyncSuccess: state.inbound.imapSyncSuccess,
    imapSyncError: state.inbound.imapSyncError,
    emailDetailsLoading: state.inbound.emailDetailsLoading,
    emailDetailsSuccess: state.inbound.emailDetailsSuccess,
    emailDetailsError: state.inbound.emailDetailsError,
    templateDownloadError: state.inbound.templateDownloadError,
    templateDownloadLoading: state.inbound.templateDownloadLoading,
    templateDownloadSuccess: state.inbound.templateDownloadSuccess,
    importCsvLoading: state.inbound.importCsvLoading,
    importCsvSuccess: state.inbound.importCsvSuccess,
    importCsvError: state.inbound.importCsvError,
    contactListLoading: state.inbound.contactListLoading,
    contactListSuccess: state.inbound.contactListSuccess,
    contactListError: state.inbound.contactListError,
    deleteContactLoading: state.inbound.deleteContactLoading,
    deleteContactSuccess: state.inbound.deleteContactSuccess,
    deleteContactError: state.inbound.deleteContactError,
    addedEnquiryContactLoading: state.inbound.addedEnquiryContactLoading,
    addedEnquiryContactSuccess: state.inbound.addedEnquiryContactSuccess,
    addedEnquiryContactError: state.inbound.addedEnquiryContactError,
    otherEmailConfigLoading: state.inbound.otherEmailConfigLoading,
    otherEmailConfigSuccess: state.inbound.otherEmailConfigSuccess,
    otherEmailConfigError: state.inbound.otherEmailConfigError,
    importHistoryLoading: state.inbound.importHistoryLoading,
    downloadHistoryDataSuccess: state.inbound.downloadHistoryDataSuccess,
    downloadHistoryDataError: state.inbound.downloadHistoryDataError,
    downloadHistoryDataLoading: state.inbound.downloadHistoryDataLoading,
    inboundDeactivateError: state.inbound.inboundDeactivateError,
    inboundDeactivateSuccess: state.inbound.inboundDeactivateSuccess,
    inboundDeactivateLoading: state.inbound.inboundDeactivateLoading,
  };
};

const mapDispatchToProps = (dispatch: TypedDispatch): DispatchProps => {
  return {
    CongigEmail: (data: EmailConfigDTO) => {
      dispatch(configEmail(data));
    },
    CreateEnquiry: (data: NurtureLead) => {
      dispatch(nurtureLead(data));
    },
    GetMailConfigList: (id: string) => {
      dispatch(getMailConfigsList(id));
    },
    GetMailEntriesByInstitute: (
      id: string,
      lastEvaluatedKey: string,
      limit: number,
      lastEvaluatedSortKey: string
    ) => {
      dispatch(
        getMailEntriesByInstitute({
          id,
          lastEvaluatedKey,
          limit,
          lastEvaluatedSortKey,
        })
      );
    },
    SaveEmailConfigurationDetails: (data: any) => {
      dispatch(saveEmailConfigDetails(data));
    },
    DeleteEmails: (data: any) => {
      dispatch(deleteInboundEmail(data));
    },
    ImapEmailSync: (data: ImapSyncData) => {
      dispatch(imapSyncEmail(data));
    },
  };
};
export interface EmailListProps extends StateProps, DispatchProps {}
export const EmailListComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(EmailListing);
